export default {
  location: [1, 2],
  pcHeight: 10,
  mHeight: 10,
  bgColor: '#ffffff'
};